<template>
  <v-container v-if="hasCanBusSettings">
    <FormRow 
      label="Enabled CAN Bus"
      :input-payload="enable"
      :check-box="true"
      :label-width="6"
      :input-width="6"
      @parseNewVAl="parseNewVal($event, 'enable', 'CAN Bus / Enabled CAN Bus')"
    />
    <FormRow 
      label="Disable reading when ignition off"
      :input-payload="disableOnAccShutoff"
      :check-box="true"
      :label-width="6"
      :input-width="6"
      @parseNewVAl="parseNewVal($event, 'disableOnAccShutoff', 'CAN Bus / Disable reading when ignition off')"
    />
  </v-container>
</template>

<script>

import FormRow from '../components/FormRow.vue';

import { deviceConfigMixin } from '@/mixins/deviceConfigMixin.js';

export default {
  name: 'CanBus',
  components: {
    FormRow
  },
  mixins: [deviceConfigMixin],
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  computed: {
    enable() {
      return JSON.parse(this.config.device_config.peripheral[0].canbus[0].enable[0]);
    },
    disableOnAccShutoff() {
      return JSON.parse(this.config.device_config.peripheral[0].canbus[0].disableOnAccOff[0]);
    },
    hasCanBusSettings() {
      return this.config && this.config.device_config.peripheral[0].canbus ? true : false;
    }
  },
  methods: {
    configPropMapper(key) {
      let map = {
        'enable': 'device_config.peripheral[0].canbus[0].enable[0]',
        'disableOnAccShutoff': 'device_config.peripheral[0].canbus[0].disableOnAccOff[0]'
      }

      return map[key];
    },

    parseNewVal(val, id, label) {
      let payload = {
        newValue: this.returnMappedVal(val, []),
        key: this.configPropMapper(id),
        label: label
      }
      this.$emit('settingsUpdated', payload);
    },
  }
}
</script>